import styled from 'styled-components';
import { space } from 'styled-system';

const SeparatorStyles = styled.div`
  ${space}

  position: relative;
  text-align: center;

  &::before {
    background: ${props => props.theme.colors.separator};
    display: block;
    content: '';
    position: absolute;
    left: 0;
    height: 0.0625rem;
    right: 0;
    top: 50%;
    margin-top: -0.0625rem;
  }
`;

export default SeparatorStyles;
